import React from 'react'
import {
    ColumnMove,
    ColumnRank,
    ColumnBib,
    ColumnName,
    ColumnNoc,
    ColumnResult,
    ColumnDifference,
    ColumnCompensation,
} from "components/common/TableColumns"
import { createColumnsMixedSummary, createColumnsSummary } from 'components/sports/tri/helper/TriHelpers'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDown, faArrowUp
} from "@fortawesome/free-solid-svg-icons";
import Movement from "components/presentation/Movement"

/* Current first athlete*/
function getCurrent(props) {
    return (
        props.currentSplit === '999' ? props.finalSplit : props.currentSplit
    )
}

/* Current by  athlete*/
function getCurrentAth(props) {
    const max = props.extendedResults.reduce((prev, current) => (prev.er_pos > current.er_pos) ? prev : current)
    return (
        max.er_pos
    )
}

export function ColumnTotalTime({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTotalTime',
    hasIrm = true
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (
                props?.extendedResults
                    ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.courseSplit], er_pos: [props.currentSplit] }).er_sortorder
                    : ''
            ),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'TotalTime',
            Cell: (props) => (
                (props.cell.row.original.resultType !== 'IRM')
                    ? props.cell.row.original?.extendedResults
                        ? findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.cell.row.original.courseSplit], er_pos: [props.cell.row.original.currentSplit] }).er_value
                        : ''
                    : props.cell.row.original.resultIrm
            ),
        }
    )
}

export function ColumnRankSummary({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderRank',
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (
                props?.extendedResults
                    ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.courseSplit], er_pos: [props.currentSplit] }).er_sortorder
                    : ''
            ),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankSummary',
            Cell: (props) => (
                props.cell.row.original?.extendedResults
                    ? findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.cell.row.original.courseSplit], er_pos: [props.cell.row.original.currentSplit] }).er_rank
                    : ''
            ),
        }
    )
}

export function ColumnMoveSummary({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    type = ''
}) {
    return (
        {
            Header: () => (<><FontAwesomeIcon icon={faArrowUp} /> <FontAwesomeIcon icon={faArrowDown} /></>),
            accessor: (props) => {
                let value = '';
                if (type === 'extendedResults') {
                    value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.courseSplit], er_pos: [props.currentSplit] })
                } else {
                    value = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: [props.cell.row.original.courseSplit], er_pos: [props.cell.row.original.currentSplit] })
                }
                return (value.er_move)
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Move',
            Cell: (props) => (
                <Movement move={props.value} />
            )
        }
    )
}


export function TableColumnsLive(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnMoveSummary({ type: 'extendedResults' }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}

export function TableColumnsMixedLive(columnsAdded) {
    let columnsExt = createColumnsMixedSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnMoveSummary({ type: 'extendedResults' }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}

export function TableColumnsLiveParasEventsPTVPTW(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnMoveSummary({ type: 'extendedResults' }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnCompensation({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}

export function TableColumnsLiveSM(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnMoveSummary({ type: 'extendedResults' }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}


export function TableColumnsMixedLiveSM(columnsAdded) {
    let columnsExt = createColumnsMixedSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnMoveSummary({ type: 'extendedResults' }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}

export function TableColumnsFinish(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnBib({ label: "HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]

    )
}

export function TableColumnsMixedFinish(columnsAdded) {
    let columnsExt = createColumnsMixedSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnBib({ label: "HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]

    )
}

export function TableColumnsFinishParasEventsPTVPTW(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnBib({ label: "HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnCompensation({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]

    )
}

export function TableColumnsFinishSM(columnsAdded) {
    let columnsExt = createColumnsSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}

export function TableColumnsMixedFinishSM(columnsAdded) {
    let columnsExt = createColumnsMixedSummary(columnsAdded);
    return (
        [
            ColumnRankSummary({}),
            ColumnNoc({}),
            ColumnName({}),

            ColumnTotalTime({}),
            ...columnsExt,

        ]
    )
}